const colorMap: Record<string, string> = {
  consolidationFacility: '#F2A900',
  cutFacility:           '#D62D38',
  distributionFacility:  '#3ED3F2',
  outboundFacility:      '#F2A900',
  warehouse:             '#002F67',
};

export function generateFacilityPinSvg(facilityTypes: string[]): string {
  const hasOutbound     = facilityTypes.includes('outboundFacility');
  const hasConsolidation = facilityTypes.includes('consolidationFacility');

  const colors = facilityTypes
    .filter(t => t !== 'outboundFacility' && t !== 'consolidationFacility')
    .map(t => colorMap[t])
    .filter(Boolean);

  if (colors.length === 0 && !hasOutbound) colors.push('blue');

  const cx = 18, cy = 17, outerR = 13;
  const innerR = hasOutbound ? 10 : 13;

  let segments = '';
  if (colors.length === 1) {
    segments = `<path d="M${cx} ${cy - innerR + 1}C${cx + innerR - 1} ${cy - innerR + 1} ${cx + innerR - 1} ${cy - 1} ${cx + innerR - 1} ${cy}
      C${cx + innerR - 1} ${cy + innerR - 3} ${cx} ${cy + innerR + 8} ${cx} ${cy + innerR + 8}
      C${cx} ${cy + innerR + 8} ${cx - innerR + 1} ${cy + innerR - 3} ${cx - innerR + 1} ${cy}
      C${cx - innerR + 1} ${cy - 1} ${cx - innerR + 1} ${cy - innerR + 1} ${cx} ${cy - innerR + 1}Z"
      fill="${colors[0]}" />`;
  } else if (colors.length === 2) {
    segments = `
      <path d="M${cx} ${cy - innerR + 1}C${cx - innerR + 1} ${cy - innerR + 1} ${cx - innerR + 1} ${cy - 1} ${cx - innerR + 1} ${cy}
        C${cx - innerR + 1} ${cy + innerR - 3} ${cx} ${cy + innerR + 8} ${cx} ${cy + innerR + 8} L${cx} ${cy} Z" fill="${colors[0]}" />
      <path d="M${cx} ${cy - innerR + 1}C${cx + innerR - 1} ${cy - innerR + 1} ${cx + innerR - 1} ${cy - 1} ${cx + innerR - 1} ${cy}
        C${cx + innerR - 1} ${cy + innerR - 3} ${cx} ${cy + innerR + 8} ${cx} ${cy + innerR + 8} L${cx} ${cy} Z" fill="${colors[1]}" />`;
  } else if (colors.length >= 3) {
    segments = `
      <path d="M${cx} ${cy - innerR + 1}C${cx + innerR - 1} ${cy - innerR + 1} ${cx + innerR - 1} ${cy - 1} ${cx + innerR - 1} ${cy} L${cx} ${cy} Z" fill="${colors[0]}" />
      <path d="M${cx} ${cy} L${cx + innerR - 1} ${cy} C${cx + innerR - 1} ${cy + innerR - 3} ${cx} ${cy + innerR + 8} ${cx} ${cy + innerR + 8} L${cx} ${cy} Z" fill="${colors[1]}" />
      <path d="M${cx} ${cy} L${cx} ${cy + innerR + 8} C${cx} ${cy + innerR + 8} ${cx - innerR + 1} ${cy + innerR - 3} ${cx - innerR + 1} ${cy} Z" fill="${colors[2]}" />
      <path d="M${cx - innerR + 1} ${cy} C${cx - innerR + 1} ${cy - 1} ${cx - innerR + 1} ${cy - innerR + 1} ${cx} ${cy - innerR + 1} L${cx} ${cy} Z" fill="${colors[0]}" />`;
  }

  const borderPath = hasOutbound
    ? `<path d="M${cx} ${cy - outerR + 1}C${cx + outerR - 1} ${cy - outerR + 1} ${cx + outerR - 1} ${cy - 1} ${cx + outerR - 1} ${cy}
        C${cx + outerR - 1} ${cy + outerR - 3} ${cx} ${cy + outerR + 8} ${cx} ${cy + outerR + 8}
        C${cx} ${cy + outerR + 8} ${cx - outerR + 1} ${cy + outerR - 3} ${cx - outerR + 1} ${cy}
        C${cx - outerR + 1} ${cy - 1} ${cx - outerR + 1} ${cy - outerR + 1} ${cx} ${cy - outerR + 1}Z"
        fill="#F2A900" />`
    : '';

  const iconShape = hasConsolidation
    ? `<path d="M${cx} 10 L19.9 16 H26 L21 19.9 L23 26 L${cx} 22.5 L13 26 L15 19.9 L10 16 H16.1 L${cx} 10Z" fill="white"/>`
    : `<circle cx="${cx}" cy="${cy}" r="4" fill="white"/>`;

  return `<svg xmlns="http://www.w3.org/2000/svg" width="36" height="48" viewBox="0 0 36 48" fill="none">
    ${borderPath}
    ${segments}
    ${iconShape}
  </svg>`;
}